/**
 * Which marketing posts count as "awaiting content review": ONE definition shared by the server
 * nav-badge count (functions marketing getReviewCount) and the Marketing content list, so the
 * badge and the list it links to can never disagree (#3953).
 *
 * Briefings live on their own tab and carry access tokens (owner/manager only), so they are never
 * content-review posts. A post with no `type` (164 of 165 real posts, measured 2026-10-01) IS one.
 */
export const MARKETING_BRIEFING_TYPE = 'briefing';
export const CONTENT_REVIEW_STATUS = 'review';

export function isMarketingBriefing(post: { readonly type?: unknown }): boolean {
  return post.type === MARKETING_BRIEFING_TYPE;
}

export function isAwaitingContentReview(post: { readonly status?: unknown; readonly type?: unknown }): boolean {
  return post.status === CONTENT_REVIEW_STATUS && !isMarketingBriefing(post);
}
